'use client';

import React from 'react';
import { CoachingCard } from '../Common/Coachingcard';
import { COACHING_OFFERS } from '@/constants/coaching';

const CoachingServices: React.FC = () => {
  return (
    <section className="bg-white px-4 pb-12 md:px-5 md:pb-14">
      <div className="mx-auto max-w-346.25">
        <h2 className="text-center font-red-hat text-[30px] font-light leading-10 tracking-[0.2px] text-[#1B365E] sm:text-[40px] sm:leading-[53px]">
          Services de Coaching
        </h2>

        {/* Services grid */}
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3">
          {COACHING_OFFERS.map((offer) => (
            <CoachingCard
              key={offer.href}
              title={offer.label}
              href={offer.href}
              category={offer.category}
              audience={offer.audience}
              description={offer.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoachingServices;
